import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const HomeIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 15" },
        React.createElement("path", { d: "M13.7906 4.85031L7.29041 0.207492C7.11652 0.0833424 6.883 0.0833424 6.70917 0.207492L0.20935 4.85031C0.078 4.9443 0 5.09579 0 5.25729V14.5C0 14.7761 0.22388 15 0.5 15H13.5C13.7761 15 14 14.7761 14 14.5V5.25729C14 5.09579 13.922 4.9443 13.7906 4.85031ZM8.66669 12.5832C8.66669 12.8134 8.48011 13 8.25 13H5.75C5.5199 13 5.33331 12.8135 5.33331 12.5832V9.66659C5.33331 8.74606 6.07953 7.99996 7 7.99996C7.92047 7.99996 8.66669 8.74605 8.66669 9.66659V12.5832Z" })));
};

export { HomeIcon };
//# sourceMappingURL=HomeIcon.esm.js.map
